<div class="main-content">
	<div class="col-md-12">
		<div class="container-fluid tp-box" [@flipState]="flip">
			<div class="backside tp-box__side tp-box__back" [ngClass]="flip != 'inactive' ? '' : 'd-none'">
				<div class="cw-wrap pd-flip-back" [ngStyle]="flipThemeVars">
					<div class="cw-icon-badge pointer" (click)="toggleFlip()" title="Back">
						<i class="material-icons">arrow_back</i>
					</div>
					<div class="cw-header">
						<div class="cw-title-group">
							<span class="cw-title">{{ subtitle }}</span>
						</div>
					</div>
					<div class="cw-body" *ngIf="viewingdata">
						<app-open-purchases [title]="subtitle" [dataset]="viewdata" *ngIf="viewapp == 'pos'"></app-open-purchases>
						<app-purchasing-inbound [title]="subtitle" [dataset]="viewdata" *ngIf="viewapp == 'inbound'"></app-purchasing-inbound>
						<app-purchasing-grns [title]="subtitle" [dataset]="viewdata" *ngIf="viewapp == 'grns'"></app-purchasing-grns>
						<app-purchase-backorders [title]="subtitle" [dataset]="viewdata" *ngIf="viewapp == 'backorders'"></app-purchase-backorders>
					</div>
				</div>
			</div>

			<div class="row tp-box__side tp-box__front purchasing-dashboard-row" id="frontside">
				<div class="col-lg-4 col-md-4 col-sm-6 dashboard-stat-col">
					<app-dashboard-stat-card
						title="Open PO's"
						icon="move_to_inbox"
						accent="info"
						[value]="totals.open"
						[loading]="!purchaseDataReady"
						[showView]="purchaseDataReady && totals.open > 0"
						(view)="showData(purchaseorders, 'pos', 'Open PO\'s')">
					</app-dashboard-stat-card>
				</div>

				<div class="dashboard-stat-col"
					[ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='Open GRNs', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='Open GRNs'}">
					<app-outstanding-grns (viewData)="toggleFlipTest($event)"></app-outstanding-grns>
				</div>

				<div class="col-lg-4 col-md-4 col-sm-6 dashboard-stat-col">
					<app-dashboard-stat-card
						title="Back Order Items"
						icon="pending_actions"
						accent="danger"
						[value]="backorders?.length"
						[loading]="!backordersReady"
						[showView]="backordersReady && backorders?.length > 0"
						(view)="showData(backorders, 'backorders', 'Back Order Items')">
					</app-dashboard-stat-card>
				</div>

				<div class="col-lg-4 col-md-4 col-sm-6 dashboard-stat-col">
					<app-dashboard-stat-card
						title="Partially Received PO's"
						icon="inbox"
						accent="danger"
						[value]="partials?.length"
						[loading]="!purchaseDataReady"
						[showView]="purchaseDataReady && partials?.length > 0"
						(view)="showData(partials, 'pos', 'Partially Received')">
					</app-dashboard-stat-card>
				</div>

				<div class="col-lg-4 col-md-4 col-sm-6 dashboard-stat-col">
					<app-dashboard-stat-card
						title="Inbound PO's"
						icon="inbox"
						accent="warning"
						[value]="inbound?.length"
						[loading]="!purchaseDataReady"
						[showView]="purchaseDataReady && inbound?.length > 0"
						(view)="showData(inbound, 'inbound', 'Inbound')">
					</app-dashboard-stat-card>
				</div>

				<div class="col-lg-4 col-md-4 col-sm-6 dashboard-stat-col">
					<app-dashboard-stat-card
						title="Ready To Invoice"
						icon="receipt"
						accent="success"
						[value]="invoice?.length"
						[loading]="!purchaseDataReady"
						[showView]="purchaseDataReady && invoice?.length > 0"
						(view)="showData(invoice, 'grns', 'Ready To Invoice')">
					</app-dashboard-stat-card>
				</div>

				<div class="col-lg-4 col-md-4 col-sm-6 dashboard-stat-col">
					<app-dashboard-stat-card
						title="Invoice Issues"
						icon="thumb_down_alt"
						accent="primary"
						[value]="invoice_issues?.length"
						[loading]="!purchaseDataReady"
						[showView]="purchaseDataReady && invoice_issues?.length > 0"
						(view)="showData(invoice_issues, 'pos', 'Invoice Issues')">
					</app-dashboard-stat-card>
				</div>

				<div class="col-lg-4 col-md-4 col-sm-6 dashboard-stat-col">
					<app-dashboard-stat-card
						title="Vendor Returns"
						icon="assignment_return"
						accent="danger"
						[value]="returns?.length"
						[loading]="!purchaseDataReady"
						[showView]="purchaseDataReady && returns?.length > 0"
						(view)="showData(returns, 'pos', 'Vendor Returns')">
					</app-dashboard-stat-card>
				</div>
			</div>
		</div>
	</div>
</div>
